(() => {
  'use strict';
  if (window.AWStoqCardGuard?.version === '2.1.0') return;

  const targetLabel = 'prevenez-moi quand disponible';
  const normalize = (value = '') => String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const isStoqNotifyButton = (node) => {
    if (!(node instanceof Element) || !node.matches('button,a,[role="button"]')) return false;
    const label = node.getAttribute('aria-label') || node.textContent || '';
    return normalize(label).includes(targetLabel);
  };

  const shells = () => {
    const set = new Set();
    document.querySelectorAll('[data-aw-product-card]').forEach((card) => {
      set.add(card.closest('[data-aw-product-shell],[data-aw-search-result]') || card);
    });
    return [...set];
  };

  const productCardFor = (shell) => shell.matches('[data-aw-product-card]') ? shell : shell.querySelector('[data-aw-product-card]');

  const isAvailableShell = (shell) => {
    const explicit = shell.getAttribute('data-aw-available');
    if (explicit === 'true') return true;
    if (explicit === 'false') return false;
    return productCardFor(shell)?.getAttribute('data-aw-product-available') === 'true';
  };

  const restorePrimary = (button) => {
    button.dataset.awStoqPrimary = 'true';
    delete button.dataset.awStoqDuplicate;
    button.removeAttribute('aria-hidden');
    button.style.removeProperty('display');
    if (button.dataset.awStoqPrevTabindex !== undefined) {
      const previous = button.dataset.awStoqPrevTabindex;
      if (previous === '') button.removeAttribute('tabindex');
      else button.setAttribute('tabindex', previous);
      delete button.dataset.awStoqPrevTabindex;
    }
  };

  const neutralize = (button) => {
    button.dataset.awStoqDuplicate = 'true';
    button.removeAttribute('data-aw-stoq-primary');
    if (button.dataset.awStoqPrevTabindex === undefined) button.dataset.awStoqPrevTabindex = button.getAttribute('tabindex') || '';
    button.setAttribute('aria-hidden', 'true');
    button.setAttribute('tabindex', '-1');
    button.style.setProperty('display', 'none', 'important');
    const parent = button.parentElement;
    if (parent && !parent.matches('[data-aw-stoq-slot],[data-aw-product-card],[data-aw-product-shell],[data-aw-search-result]') && parent.children.length === 1) {
      parent.dataset.awStoqDuplicateWrap = 'true';
    }
  };

  const cleanShell = (shell) => {
    const buttons = [...shell.querySelectorAll('button,a,[role="button"]')].filter(isStoqNotifyButton);
    if (!buttons.length) return;

    if (isAvailableShell(shell)) {
      buttons.forEach(neutralize);
      return;
    }

    let keep = buttons.find((button) => button.dataset.awStoqPrimary === 'true' && button.dataset.awStoqDuplicate !== 'true');
    if (!keep) keep = buttons[buttons.length - 1];
    restorePrimary(keep);
    buttons.forEach((button) => { if (button !== keep) neutralize(button); });

    const slot = shell.querySelector('[data-aw-stoq-slot]');
    if (!slot || slot.contains(keep)) return;
    const oldParent = keep.parentElement;
    const form = keep.closest('form');
    const movable = form && shell.contains(form) && form.querySelectorAll('button,a,[role="button"]').length === 1 ? form : keep;
    slot.appendChild(movable);
    if (oldParent && oldParent !== movable && oldParent !== slot && !oldParent.textContent.trim() && oldParent.children.length === 0) {
      oldParent.dataset.awStoqVacatedWrap = 'true';
    }
  };

  const scan = () => shells().forEach(cleanShell);
  let frame = 0;
  const schedule = () => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      scan();
    });
  };

  const start = () => {
    scan();
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((mutation) => mutation.addedNodes.length)) schedule();
    });
    const observedRoots = new WeakSet();
    const observeRoots = (scope = document) => {
      const roots = [];
      if (scope?.matches?.('[data-aw-collection-grid],[data-aw-search-results-grid]')) roots.push(scope);
      scope?.querySelectorAll?.('[data-aw-collection-grid],[data-aw-search-results-grid]').forEach((root) => roots.push(root));
      roots.forEach((root) => {
        if (observedRoots.has(root)) return;
        observedRoots.add(root);
        observer.observe(root, { childList: true, subtree: true });
      });
    };
    observeRoots(document);
    document.addEventListener('shopify:section:load', (event) => {
      observeRoots(event.target);
      schedule();
    });
    window.AWStoqCardGuard = { version: '2.2.0', scan, observer, observeRoots };
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
